import { Loader2 } from 'lucide-react';

import { DocumentList } from '@/components/documents/DocumentList';
import { DocumentUploadForm } from '@/components/documents/DocumentUploadForm';
import { useAuth } from '@/hooks/use-auth';
import { useDocuments, useUploadDocument } from '@/hooks/use-documents';

export default function DocumentsPage() {
  const { serviceId } = useAuth();
  const { data: documents, isLoading, isError } = useDocuments(serviceId);
  const uploadMutation = useUploadDocument();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-center py-12">
        <p className="text-sm text-destructive">
          Failed to load documents. Please try again later.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Documents</h1>
      <DocumentUploadForm
        onUpload={(data) => uploadMutation.mutate(data)}
        isUploading={uploadMutation.isPending}
      />
      <DocumentList documents={Array.isArray(documents) ? documents : []} />
    </div>
  );
}
